import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loading';
import { Grid, Input, Card } from 'semantic-ui-react';
import AddPurchaserContact from './add';
import EditPurchaserContact from './edit';
import DeletePurchaserContact from './delete';

const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing.unit,
  },
});

class ViewContact extends React.Component {
  state = {
    open: false,
    fullWidth: true,
    load: false,
    message: '',
    purchaserContact: [],
    maxWidth: 'md',
    addPurchaserContact: false,
    editPurchaserContact: false,
    deletePurchaserContact: false,
  };

  componentDidMount() {
    this.getPurchaserContact();
  }

  componentDidUpdate(props) {
    if (props.id != this.props.id) {
      this.getPurchaserContact();
    }
  }

  getPurchaserContact() {
    let context = this;
    context.setState({
      addPurchaserContact: false,
      editPurchaserContact: false,
      deletePurchaserContact: false,
      load: true,
      message: 'Getting Purchaser Contact'
    });
    let data1 = { 'purchaser_id': this.props.id }
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'purchaser/getpurchaserscontact.php',
      success: function(data)
      {
        console.log(data);
        try {
          data = JSON.parse(data);
          for (var i = 0; i < data.length; i++) {
            let s = 1;
            data[i].sino = s + i;
          }
          context.setState({
            purchaserContact: data,
            load: false,
            open: true
          });
        } catch (e) {
          context.setState({
            load: false,
            purchaserContact: [],
          });
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        console.log(e);
        context.setState({
          load: false,
          data: false
        });
      }
    });
  }

  handleClose = () => {
    this.setState({
      addPurchaserContact: false,
      editPurchaserContact: false,
      deletePurchaserContact: false,
    });
  }

  render() {
    const { classes } = this.props;
    let add, edit;
    if (this.state.addPurchaserContact) {
      add = (<AddPurchaserContact addPurchaserContact={this.state.addPurchaserContact}
              handleClose={this.handleClose.bind(this)} id={this.props.id}
              getPurchaserContact={this.getPurchaserContact.bind(this)} />);
    }
    if (this.state.editPurchaserContact) {
      edit = (<EditPurchaserContact
                editid={this.state.editid} editname={this.state.editname}
                editmobile={this.state.editmobile} editdesignation={this.state.editdesignation}
                editmail={this.state.editmail}
                editPurchaserContact={this.state.editPurchaserContact}
                handleClose={this.handleClose.bind(this)}
                getPurchaserContact={this.getPurchaserContact.bind(this)} />);
    }
    return (
      <React.Fragment>
        <Dialog  fullWidth={this.state.fullWidth}
          maxWidth={this.state.maxWidth}   open={this.props.viewContact}
          onClose={this.props.handleClose}  aria-labelledby="max-width-dialog-title" >

          <DialogTitle id="max-width-dialog-title">Purchaser Contact</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Card fluid>
                <table width='100%' id='table'>
                  <tr id='tableheader'>
                    <th style={{width: '10%'}}><center>Sino</center></th>
                    <th style={{width: '20%'}}><center>Name</center></th>
                    <th style={{width: '15%'}}><center>Mobile</center></th>
                    <th style={{width: '20%'}}><center>Designation</center></th>
                    <th style={{width: '15%'}}><center>Email</center></th>
                    { this.props.menuPermission.edit ?
                      <th style={{width: '10%'}}><center>Edit</center></th>:''
                    }
                  </tr>
                  { this.state.purchaserContact.map((z) => {
                      return (
                        <tr>
                          <td><center>{z.sino}</center></td>
                          <td><center>{z.name}</center></td>
                          <td><center>{z.mobile}</center></td>
                          <td><center>{z.designation}</center></td>
                          <td><center>{z.email}</center></td>
                          { this.props.menuPermission.edit ?
                            <td style={{ cursor: 'pointer', color: '#4F9CCD' }}
                                onClick={ () => { this.setState({ editPurchaserContact: true,
                              editid: z.id, editname: z.name, editmobile: z.mobile,
                              editdesignation: z.designation, editmail: z.email }) } }>
                              <center>Edit</center>
                            </td>:''
                          }
                          
                        </tr>
                      );
                    }
                  )}
                </table>
                {add}{edit}
                <Card.Content extra>
                  { this.props.menuPermission.add ?
                    <Button primary style={{display: this.props.purchaseredit}} onClick = { () => {this.setState({ addPurchaserContact: true }) } } >Add Contact</Button>:''
                  }
                </Card.Content>
              </Card>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.handleClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

ViewContact.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ViewContact);
